import { motion } from 'framer-motion';
import SEOHead from '../components/SEOHead';

const steps = [
  {
    number: '01',
    title: 'Pick the right service',
    body: 'Start with driver hire or cab hire. Drivor supports city driving, outstation travel, office pickup and drop, night drivers, permanent duty, valet and corporate drivers, local cabs, airport transfers, local trips, and holiday planning.',
  },
  {
    number: '02',
    title: 'Add route, schedule, and notes',
    body: 'Enter pickup details, drop location when needed, start and end time, estimated duration or distance, and any customer notes that help the assigned driver or cab partner prepare.',
  },
  {
    number: '03',
    title: 'Review the fare estimate',
    body: 'Get an estimated fare before confirming. Driver hire estimates use expected hours, while cab hire estimates can account for approximate distance and the selected service type.',
  },
  {
    number: '04',
    title: 'Confirm and track the booking',
    body: 'Once submitted, the booking moves into the Drivor dashboard where customers can follow active, completed, and cancelled requests with payment and support workflows available.',
  },
];

const HowItWorks = () => (
  <>
    <SEOHead
      title="How it works"
      description="See how Drivor handles driver hire and cab hire bookings from service selection to fare estimate, confirmation, tracking, and support."
      url="https://drivor.in/how-it-works"
    />

    <div className="border-b border-slate-200 bg-white">
      <div className="container-custom py-16 lg:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow">How it works</p>
          <h1 className="section-title mt-2">From travel need to confirmed booking</h1>
          <p className="mt-4 text-lg text-surface-body">
            Drivor keeps the booking flow clear: choose a service, share the route
            and schedule, review the estimate, then manage the request from your
            booking dashboard.
          </p>
        </div>
      </div>
    </div>

    <div className="bg-surface-page py-16">
      <div className="container-custom">
        <div className="mx-auto max-w-3xl space-y-10">
          {steps.map(({ number, title, body }, i) => (
            <motion.div
              key={number}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              className="flex gap-6 rounded-2xl border border-slate-200 bg-white p-8 shadow-card"
            >
              <span className="shrink-0 text-4xl font-bold text-primary-200">{number}</span>
              <div>
                <h2 className="text-xl font-semibold text-surface-ink">{title}</h2>
                <p className="mt-3 leading-relaxed text-surface-body">{body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </>
);

export default HowItWorks;
